const SPECIAL_CHARACTERS_STR = "!@#$%^&*()-_=+[]{}\\|;:'\",./<>?`~√";

export const SPECIAL_CHARACTERS = SPECIAL_CHARACTERS_STR.split("");

export function containsSpecialCharacter(str: string): boolean {
  for (const chr of str) {
    if (SPECIAL_CHARACTERS_STR.indexOf(chr) !== -1) {
      return true;
    }
  }

  return false;
}
